// @flow
import type { ReduxState } from '../../types';

export const getDevTools = (state: ReduxState) => {
  return state.devTools;
};
